import { useTranslation } from "react-i18next";
import CompareStripedRows from "./CompareStripedRows";
import lookupTables from "../../data/lookup_tables.json";
import { V1Clinic } from "../../types/v1_schemas";
import { optionWithId } from "../../types/lookup";

function PopulationsTable({
  providerA,
  providerB,
}: {
  providerA: V1Clinic;
  providerB: V1Clinic;
}) {
  const { t } = useTranslation();

  let populationsServedA: optionWithId[] = [];
  let populationsServedB: optionWithId[] = [];

  providerA?.clinicPatientEthnicities?.forEach(function (value) {
    if (value?.patientEthnicityText?.length) {
      if (value.patientEthnicityText.toLowerCase() === "other")
        value.patientEthnicityText = "More ethnicities";
      if (value.patientEthnicityText.toLowerCase() === "otro")
        value.patientEthnicityText = "Más etnias";
      if (value?.patientEthnicityWriteIn?.length) {
        populationsServedA.push({
          id: 0,
          lineageText: value?.lineageText || "",
          description: value.patientEthnicityText,
          translate: value.patientEthnicityWriteIn,
        });
        //   value.patientEthnicityText + ": " + value.patientEthnicityWriteIn
        // );
      } else
        populationsServedA.push({
          id: 0,
          lineageText: value?.lineageText || "",
          description: value.patientEthnicityText,
          translate: value.patientEthnicityText,
        });
    }
  });

  providerA?.clinicCommunityServeds?.forEach(function (value) {
    if (value?.patientCommunityText?.length) {
      if (value.patientCommunityText.toLowerCase() === "other")
        value.patientCommunityText = "More communities";
      if (value.patientCommunityText.toLowerCase() === "otro")
        value.patientCommunityText = "Más comunidades";
      if (value.patientCommunityWriteIn?.length) {
        populationsServedA.push({
          id: 0,
          lineageText: value?.lineageText || "",
          description: value.patientCommunityText,
          translate: value.patientCommunityWriteIn,
        });
      } else
        populationsServedA.push({
          id: 0,
          lineageText: value?.lineageText || "",
          description: value.patientCommunityText,
          translate: value.patientCommunityText,
        });
    }
  });

  providerA?.clinicPatientGenders?.forEach(function (value) {
    if (value?.patientGenderText?.length) {
      populationsServedA.push({
        id: 0,
        lineageText: value?.lineageText || "",
        description: value.patientGenderText,
        translate: value.patientGenderText,
      });
    }
  });

  providerA?.clinicPatientAgeGroups?.forEach(function (value) {
    if (value?.patientAgeGroupText?.length) {
      populationsServedA.push({
        id: 0,
        lineageText: value?.lineageText || "",
        description: value.patientAgeGroupText,
        translate: value.patientAgeGroupText,
      });
    }
  });

  providerB?.clinicPatientEthnicities?.forEach(function (value) {
    if (value?.patientEthnicityText?.length) {
      if (value.patientEthnicityText.toLowerCase() === "other")
        value.patientEthnicityText = "More ethnicities";
      if (value.patientEthnicityText.toLowerCase() === "otro")
        value.patientEthnicityText = "Más etnias";
      if (value?.patientEthnicityWriteIn?.length) {
        populationsServedB.push({
          id: 0,
          lineageText: value?.lineageText || "",
          description: value.patientEthnicityText,
          translate: value.patientEthnicityWriteIn,
        });
      } else
        populationsServedB.push({
          id: 0,
          lineageText: value?.lineageText || "",
          description: value.patientEthnicityText,
          translate: value.patientEthnicityText,
        });
    }
  });

  providerB?.clinicCommunityServeds?.forEach(function (value) {
    if (value?.patientCommunityText?.length) {
      if (value.patientCommunityText.toLowerCase() === "other")
        value.patientCommunityText = "More communities";
      if (value.patientCommunityText.toLowerCase() === "otro")
        value.patientCommunityText = "Más comunidades";
      if (value.patientCommunityWriteIn?.length) {
        populationsServedB.push({
          id: 0,
          lineageText: value?.lineageText || "",
          description: value.patientCommunityText,
          translate: value.patientCommunityWriteIn,
        });
      } else
        populationsServedB.push({
          id: 0,
          lineageText: value?.lineageText || "",
          description: value.patientCommunityText,
          translate: value.patientCommunityText,
        });
    }
  });

  providerB?.clinicPatientGenders?.forEach(function (value) {
    if (value?.patientGenderText?.length) {
      populationsServedB.push({
        id: 0,
        lineageText: value?.lineageText || "",
        description: value.patientGenderText,
        translate: value.patientGenderText,
      });
    }
  });

  providerB?.clinicPatientAgeGroups?.forEach(function (value) {
    if (value?.patientAgeGroupText?.length) {
      populationsServedB.push({
        id: 0,
        lineageText: value?.lineageText || "",
        description: value.patientAgeGroupText,
        translate: value.patientAgeGroupText,
      });
    }
  });
  const rowData = lookupTables.patientCommunities.map((pop) => {
        return {
          label: t(pop.translate),
          compareA: !!populationsServedA?.filter(
            (f) => f.lineageText === pop.lineageText
          )[0],
          compareB: !!populationsServedB?.filter(
            (f) => f.lineageText === pop.lineageText
          )[0],
        };
      });

  return (
    <CompareStripedRows rows={rowData} title={t("populations")} hideEmptyRows />
  );
}

export default PopulationsTable;
